import React from 'react';
import './GameScreen.css';
import { useGame } from '../../contexts/GameContext';
import CardRevealPhase from './CardRevealPhase';
import NightPhase from './NightPhase';
import DiscussionPhase from './DiscussionPhase';
import VotingPhase from './VotingPhase';
import RoundResultPhase from './RoundResultPhase';
import ResultsPhase from './ResultsPhase';

const GameScreen = () => {
  const { 
    lobby, 
    currentPlayer,
    gamePhase
  } = useGame();

  // Render different game phases
  const renderGamePhase = () => {
    switch (gamePhase) {
      case 'CARD_REVEAL':
        return <CardRevealPhase />;
      case 'NIGHT':
        return <NightPhase />;
      case 'DISCUSSION':
        return <DiscussionPhase />;
      case 'VOTING':
        return <VotingPhase />;
      case 'ROUND_RESULT':
        return <RoundResultPhase />;
      case 'RESULTS':
        return <ResultsPhase />;
      default:
        return <div className="game-loading">Oyun yükleniyor...</div>;
    }
  };

  if (!lobby || !currentPlayer) {
    return <div className="game-loading">Oyun yükleniyor...</div>;
  }

  return (
    <div className="game-screen">
      <div className="game-header">
        <h1 className="game-title">Tanrıların Şöleni</h1>
      </div>
      
      <div className="game-content">
        {renderGamePhase()}
      </div>
    </div>
  );
};

export default GameScreen;
